// @router
import { checkAuthenticated, getProjectName } from "@/shared/utils";
import { getLandingView } from "../utils/getLandingView";

const authLayout = () => import("@/layouts/AuthLayout.vue");

const landingView = getLandingView();
const isFullPageLanding = getProjectName() === "isu";

export const authRoutes: any[] = landingView
  ? [
      {
        path: "/landing",
        name: "landing",
        redirect: "/landing/info",
        component: authLayout,
        meta: {
          redesigned: true,
          moduleName: "landing",
        },
        children: [
          {
            path: "info",
            name: "info",
            component: landingView,
            meta: {
              redesigned: true,
              label: "معرفی سامانه",
              needBaseScroll: !isFullPageLanding,
            },
            beforeEnter: async (to: any, from: any, next: any) => {
              const isAuthenticated = await checkAuthenticated();
              if (isAuthenticated) {
                next({
                  name: "dashboard",
                });
              } else {
                next();
              }
            },
          },
        ],
      },
    ]
  : [];
